import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataServiceService } from '../data-service.service';
import { Company } from '../model/Company';
import { User } from '../model/login';

@Component({
  selector: 'app-new-admin',
  templateUrl: './new-admin.component.html',
  styleUrls: ['./new-admin.component.scss']
})
export class NewAdminComponent implements OnInit {

  availableTypes = ["ADMIN", "SUPERADMIN"]
  adminType = this.availableTypes[0]
  newUser: User = {
    userId: "",
    companyId: "",
    userName: "",
    email: "",
    password: "",
    totalCreditsEntitled: undefined,
    usedCredits: undefined,
    startDate: new Date(),
    endDate: new Date(),
    status: "",
    statusRemarks: "",
    userType: "",
    lastLogin: undefined,
    user: "",
    phoneNumber: "",
    companyDetails: []
  };

  constructor(private modalService: NgbModal, private dataService: DataServiceService, private router: Router) {}

  ngOnInit(): void {}

  invalidUser() {
    if (this.newUser.user.trim() == "") return true;
    else return false;
  }

  invalidUname() {
    if (this.newUser.userName.trim() == "") return true;
    else return false;
  }

  invalidEmail() {
    if (
      !this.validateEmail(this.newUser.email) ||
      this.newUser.email.trim() == ""
    )
      return true;
    else return false;
  }

  selectType(type){
    this.adminType = type
  }

  invalidPNum() {
    if (!this.validatePhone(this.newUser.phoneNumber)) return true;
    if (
      (this.newUser.phoneNumber + "").trim() == "" ||
      this.newUser.phoneNumber.length <= 6
    ) {
      return true;
    } else return false;
  }

  invalidPassword() {
    if (!this.validatePassword(this.newUser.password)) return true;
    if ((this.newUser.password + "").trim() == "") {
      return true;
    } else return false;
  }

  invalidForm() {
    return (
      this.invalidUname() ||
      this.invalidEmail() ||
      this.invalidPNum() ||
      this.invalidPassword()
    );
  }

  validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  validatePhone = (phone) => {
    return String(phone)
      .toLowerCase()
      .match(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/);
  };

  validatePassword = (password) => {
    return String(password).match(
      /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/gm
    );
  };

  submitForm(){
    this.newUser.companyId = "-9999";
    this.newUser.status = 'Inforce';
    this.newUser.userType = this.adminType;
    this.newUser.isAdverseMediaEnabled = false;
    this.dataService.addAdmin(this.newUser)
    .then(() => {
      const but = document.getElementById("successBtn") as HTMLButtonElement;
      but.click();
      setTimeout(() => {
        this.modalService.dismissAll()
        this.router.navigate(['/all-admins'])
      }, 3000);
    })
    .catch(() => {
      const but = document.getElementById("failBtn") as HTMLButtonElement;
      but.click();
    });
  }

  openSuccessPopup(smallModalContent) {
    this.modalService.open(smallModalContent, { size: "sm" });
  }

  openFailPopup(smallModalContent2) {
    this.modalService.open(smallModalContent2, { size: "sm" });
  }

}
